import React, { ChangeEvent, useContext, useEffect } from "react";
import UserContext from "../../../../contexts/UserContext";
import SupplierContext from "../../../../contexts/SupplierContext";
import VendorContext from "../../../../contexts/VendorContext";
import IUiSocketSetup from "../../../../models/IUiSocketSetup";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IOnGetAllSupplierTokensDTO from "../../../../models/DTO/IOnGetAllSupplierTokensDTO";
import IOnGetShipstationCarriersDTO from "../../../../models/DTO/IOnGetShipstationCarriersDTO";
import * as _ from "lodash-es";
import IOnGetVendorDTO from "../../../../models/DTO/IOnGetVendorDTO";
import IOnGetVendorsDTO from "../../../../models/DTO/IOnGetVendorsDTO";
import INotification from "../../../../models/INotification";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import UiContext from "../../../../contexts/UiContext";
import ShippingCarriersEnum from "../../../../models/ShippingCarriersEnum";
import { SocketContext } from "../../../../contexts/SocketContext";
import UIService from "../../../../services/UIService";
import ChevronToggle from "../../../shared/ChevronToggle/ChevronToggle";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import Typeahead from "../../../shared/Typeahead/Typeahead";
import OwInputWrapper from "../../../shared/OwInputWrapper/OwInputWrapper";
import OwDateInput from "../../../shared/OwDateInput/OwDateInput";
import OwCheckbox from "../../../shared/OwCheckbox/OwCheckbox";
import OwButton from "../../../shared/OwButton/OwButton";
import OwSelectOption from "../../../shared/OwSelectOption/OwSelectOption";
import { useNavigate, useLocation } from "react-router-dom";
import ShipmentStatusEnum from "../../../../models/ShipmentStatusEnum";
import IVendorModel from "../../../../models/IVendorModel";
import UserService from "../../../../services/UserService";
import IUpdateTokenSettingsDTO from "../../../../models/DTO/IUpdateTokenSettingsDTO";
import IGetShipstationCarriersDTO from "../../../../models/DTO/IGetShipstationCarriersDTO";
import IGetVendorDTO from "../../../../models/DTO/IGetVendorDTO";
import {useIntl} from "react-intl";

type Props = {
    order?: string;
    searchFn?: (queryString: string) => void;
    getParamsState: (
        location: any
    ) => {
        packing_list: string;
        order: string;
        po_no: string;
        vendor: string;
        has_shipments: string;
        hide_signed: boolean;
        offset: number;
        limit: number;
        shipment_type?: string;
    };
    getQueryString: (search: {
        packing_list?: string;
        order?: string;
        po_no?: string;
        vendor?: string;
        has_shipments?: string;
        offset?: number;
        limit?: number;
        shipment_type?: string;
    }) => string;
};

export const ShipmentFilterFn = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const vendorModel = useContext(VendorContext);
    const uiContext = useContext(UiContext);
    const socket = useContext(SocketContext)!;

    const location = useLocation();
    const history = useNavigate();

    const getSettingValue = (key: string, defaultValue: any) => {
        const currentToken = UserService.getCurrentToken(userModel);

        if (currentToken) {
            const settings = currentToken.settings?.shipments_filters || {};

            return settings[key] || defaultValue;
        } else {
            return defaultValue;
        }
    };

    // Vendor Field
    const [foundVendors, setFoundVendors] = React.useState<IVendorModel[] | undefined>();
    const [clearVendorTypeahead, setClearVendorTypeahead] = React.useState<boolean>(false);
    const [selectedVendor, setSelectedVendor] = React.useState<any>(null);
    const [connectedVendors, setConnectedVendors] = React.useState<any[]>([]);

    // Fields
    const [order, setOrder] = React.useState<any>("");
    const [poNo, setPoNo] = React.useState<any>("");
    const [packingList, setPackingList] = React.useState<any>("");
    const [hasShipments, setHasShipments] = React.useState<boolean>(getSettingValue("has_shipments", false));
    const [hideSigned, setHideSigned] = React.useState<any>(getSettingValue("hide_signed", true));
    const [shipmentType, setShipmentType] = React.useState<any>(getSettingValue("shipmentType", ""));

    // Date Field - Not available.
    const [dateSelectedValue, setDateSelectedValue] = React.useState<any>(null);

    // Shipment Field - Not available.
    const [shipmentStatuses, setShipmentStatuses] = React.useState<any[]>([]);
    const [shipmentStatus, setShipmentStatus] = React.useState<any>("");
    const [shippingCarrierId, setShippingCarrierId] = React.useState<any>("");

    // Sequence items
    const [hasInitialFilter, setHasInitialFilter] = React.useState<boolean>(false);
    const [hasShipstation, setHasShipstation] = React.useState<boolean>(!!supplierModel.Supplier_Integration.has_shipstation);

    // const [isConnected, setIsConnected] = React.useState<boolean>(false);
    // const [isOrderSearchDisabled, setIsOrderSearchDisabled] = React.useState<boolean>(false);
    const [isCarrierDisabled, setIsCarrierDisabled] = React.useState<boolean>(false);

    const [shipmentStatusId, setShipmentStatusId] = React.useState<any>(null);
    const [isVisible, setIsVisible] = React.useState<boolean>(true);

    const [queryString, setQueryString] = React.useState<string>("");

    const [vendors, setVendors] = React.useState<any[]>([]);
    const [shippingCarriers, setShippingCarriers] = React.useState<any[]>([]);
    const [foundUsers, setFoundUsers] = React.useState<any[]>([]);
    const [selectedUser, setSelectedUser] = React.useState<any>(null);
    const [users, setUsers] = React.useState<any[]>([]);
    const [shipstationCarriers, setShipstationCarriers] = React.useState<any[]>([]);
    const [shipstationSelectedCarrier, setShipstationSelectedCarrier] = React.useState<any>(null);

    const getShipmentTypes = () => {
        const types = [{ title: "shipment" }];

        if (supplierModel.has_local_pickup) {
            types.push({ title: "local_pickup" });
        }

        if (supplierModel.has_local_delivery) {
            types.push({ title: "local_delivery" });
        }

        if (supplierModel.has_dropshipping) {
            types.push({ title: "dropshipment" });
        }

        return types;
    };

    const shipmentTypes = getShipmentTypes();

    const getStatus = () => {
        return [
            { name: "shipments.awaiting_payment", id: ShipmentStatusEnum.AWAITING_PAYMENT },
            { name: "shipments.awaiting_fulfillment", id: ShipmentStatusEnum.AWAITING_FULFILLMENT },
            { name: "shipments.awaiting_shipment", id: ShipmentStatusEnum.AWAITING_SHIPMENT },
            { name: "shipments.awaiting_pickup", id: ShipmentStatusEnum.AWAITING_PICKUP },
            { name: "shipments.partially_shipped", id: ShipmentStatusEnum.PARTIALLY_SHIPPED },
            { name: "shipments.completed", id: ShipmentStatusEnum.COMPLETED },
            { name: "shipments.shipped", id: ShipmentStatusEnum.SHIPPED },
            { name: "shipments.cancelled", id: ShipmentStatusEnum.CANCELLED },
            { name: "shipments.declined", id: ShipmentStatusEnum.DECLINED },
            { name: "shipments.refunded", id: ShipmentStatusEnum.REFUNDED },
            { name: "shipments.verification_required", id: ShipmentStatusEnum.VERIFICATION_REQUIRED },
            { name: "shipments.partially_refunded", id: ShipmentStatusEnum.PARTIALLY_REFUNDED },
        ];
    };

    const shippingStatuses = getStatus();

    const getCarriers = () => {
        return [
            { name: "UPS", id: ShippingCarriersEnum.UPS },
            { name: "FedEx", id: ShippingCarriersEnum.FEDEX },
            { name: "USPS", id: ShippingCarriersEnum.USPS },
            { name: "TNT", id: ShippingCarriersEnum.TNT },
            { name: "DHL", id: ShippingCarriersEnum.DHL },
            { name: "3PL", id: ShippingCarriersEnum.THREEPL },
            { name: "Local", id: ShippingCarriersEnum.LOCAL },
        ];
    };

    const onGetAllSupplierTokens = (data: IOnGetAllSupplierTokensDTO) => {
        setConnectedVendors(data.tokens.connectedVendors);
    };

    const onGetShipstationCarriers = (data: IOnGetShipstationCarriersDTO) => {
        const _shipstationCarriers = _.map(data.carriers, (shipstationCarrier, index) => {
            return {
                name: `${shipstationCarrier.name} [SHIPSTATION]`,
                id: index,
                shipstationCarrier: true,
                detail: shipstationCarrier,
            };
        });

        // let shipping_carrier_id;

        const carriers: any = getCarriers().map((carrier, index) => {
            const carrierIndex = shipstationCarriers.length + index;

            return {
                name: carrier.name,
                id: carrierIndex,
                shipstationCarrier: false,
            };
        });

        const allCarriers = _shipstationCarriers.concat(carriers);

        setShippingCarriers(allCarriers);
        setShipstationCarriers(data.carriers);
    };

    const onGetVendor = (data: IOnGetVendorDTO) => {
        setSelectedVendor(data.vendor);
    };

    const onGetVendors = (data: IOnGetVendorsDTO) => {
        const _foundVendors = data.supplierVendorTokens
            .filter((item) => !!item.Vendor)
            .map((tokenData) => {
                return tokenData.Vendor!;
            });

        setFoundVendors(_foundVendors);
    };

    const onUpdateTokenSettings = () => {
        const notification: INotification = {
            message: "successfully_updated_settings",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        uiContext.notifyFn(null, notification);
    };

    const sockets: IUiSocketSetup[] = [
        { endpoint: EndpointsEnum.TokenOnGetAllSupplierTokens, fn: onGetAllSupplierTokens },
        { endpoint: EndpointsEnum.ShipstationOnGetCarriers, fn: onGetShipstationCarriers },
        { endpoint: EndpointsEnum.VendorsOnGetVendor, fn: onGetVendor },
        { endpoint: EndpointsEnum.VendorsOnGetVendors, fn: onGetVendors },
        { endpoint: EndpointsEnum.TokenOnUpdateSettings, fn: onUpdateTokenSettings },
    ];

    const initSetup = () => {
        let _hasInitialFilter = false;

        const paramsState = props.getParamsState(location);

        if (paramsState.packing_list.length || paramsState.order.length || paramsState.vendor || paramsState.po_no.length) {
            _hasInitialFilter = true;
        }

        let has_shipments = hasShipments;

        if (paramsState.has_shipments.length) {
            has_shipments = paramsState.has_shipments === "true";
        }

        setHasShipments(has_shipments);
        setHasInitialFilter(_hasInitialFilter);
        setOrder(paramsState.order);
        setPoNo(paramsState.po_no);

        if (paramsState.vendor) {
            getVendor(paramsState.vendor);
        }

        if (!_hasInitialFilter) {
            performSearch();
        }
    };

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        // initial setup
        initSetup();

        if (userModel.isSupplierUser && hasShipstation) {
            getShipstationCarriers();
        }

        return () => {
            for (const _socket of sockets) {
                socket.removeListener(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    useEffect(() => {
        if (hasInitialFilter) {
            performSearch();
        }
    }, [hasInitialFilter]);

    const getQueryString = (_location: any): string => {
        const paramsState = props.getParamsState(_location);

        paramsState.vendor = selectedVendor?.guid;
        paramsState.packing_list = packingList;
        paramsState.order = order;
        paramsState.po_no = poNo;
        paramsState.has_shipments = hasShipments ? "true" : "false";
        paramsState.hide_signed = hideSigned;
        paramsState.shipment_type = shipmentType;

        const _queryString = props.getQueryString(paramsState);

        return _queryString;
    };

    const performSearch = () => {
        const _queryString = getQueryString(location);

        setQueryString(_queryString);
        setHasInitialFilter(false);

        let isEcommMode = false;

        if (window.location.href.indexOf("ecomm") > -1) {
            isEcommMode = true;
        }

        history({
            pathname: isEcommMode? "/ecomm/shipments" : "/shipments",
            search: _queryString,
        });

        if (props.searchFn) {
            props.searchFn(_queryString);
        }
    };

    const toggleVisible = () => {
        setIsVisible(!isVisible);
    };

    const clearVendorTypeaheadFn = () => {
        setClearVendorTypeahead(false);
        setSelectedVendor(undefined);
    };

    const getVendor = (vendorGuid: string) => {
        const payload: IGetVendorDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            vendorGuid,
        };

        socket.emit(EndpointsEnum.VendorsGetVendor, payload);
    };

    const getShipstationCarriers = () => {
        if (!hasShipstation) {
            return;
        }

        const data: IGetShipstationCarriersDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
        };

        socket.emit(EndpointsEnum.ShipstationGetCarriers, data);
    };

    const findVendorsByName = (typeahead: string) => {
        const encodedTypeahead = encodeURIComponent(typeahead);

        const payload = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            queryString: `name=${encodedTypeahead}`,
        };

        socket.emit(EndpointsEnum.VendorsGetVendors, payload);
    };

    const enterSearch = (e: any) => {
        if (e.key === "Enter") {
            performSearch();
        }
    };

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        switch (name) {
            case "shipment_status_id":
                setShipmentStatus(value);
                break;

            case "shipping_carrier_id":
                setShippingCarrierId(value);
                break;

            case "has_shipments":
                setHasShipments(value);
                break;

            case "hide_signed":
                setHideSigned(value);
                break;

            case "shipmentType":
                setShipmentType(value);
                break;

            case "po_no":
                setPoNo(value);
                break;

            case "packing_list":
                setPackingList(value);
                break;

            case "order":
                setOrder(value);
                break;
        }
    };

    const handleDateChange = (date: any) => {
        setDateSelectedValue(date);
    };

    const resetSearch = () => {
        // reset back to the default from the token.
        const currentToken = UserService.getCurrentToken(userModel);

        let has_shipments = false;
        let hide_signed = true;
        let shipmentType = "";

        if (currentToken) {
            const settings = currentToken.settings || {};

            if (settings.shipments_filters) {
                if (!_.isNil(settings.shipments_filters.has_shipments) && _.isBoolean(settings.shipments_filters.has_shipments)) {
                    has_shipments = settings.shipments_filters.has_shipments;
                }

                if (!_.isNil(settings.shipments_filters.hide_signed) && _.isBoolean(settings.shipments_filters.hide_signed)) {
                    hide_signed = settings.shipments_filters.hide_signed;
                }

                if (_.isString(settings.shipments_filters.shipmentType)) {
                    shipmentType = settings.shipments_filters.shipmentType || "";
                }
            }
        }

        setFoundVendors(undefined);
        setClearVendorTypeahead(true);
        setSelectedVendor(undefined);
        setConnectedVendors([]);
        setDateSelectedValue(null);
        setShippingCarrierId("");
        setOrder("");
        setPoNo("");
        setPackingList("");
        setShipmentStatus("");
        setShipstationSelectedCarrier(null);
        setHasShipments(has_shipments);
        setHideSigned(hide_signed);
        setShipmentType(shipmentType);
        setQueryString("");
        setHasInitialFilter(true);

        // this.setState({
        //     foundVendors: [],
        //     clearVendorTypeahead: true,
        //     selectedVendor: {},
        //     connectedVendors: [],
        //     dateSelectedValue: null,
        //     shipping_carrier_id: "",
        //     order: "",
        //     po_no: "",
        //     packing_list: "",
        //     shipment_status_id: "",
        //     shipstationSelectedCarrier: null,
        //     has_shipments,
        //     hide_signed,
        //     shipmentType,
        //     queryString: "",
        // });

        // history.push({
        //     pathname: "/shipments",
        //     search: "",
        // });
    };

    const saveSearch = () => {
        const currentToken = UserService.getCurrentToken(userModel);

        if (currentToken) {
            const shipments_filters: any = {};

            const settings = ["shipment_status_id", "hide_signed", "has_shipments", "shipmentType"];

            for (const setting of settings) {
                switch (setting) {
                    case "shipment_status_id":
                        shipments_filters[setting] = shipmentStatus;
                        break;

                    case "hide_signed":
                        shipments_filters[setting] = hideSigned;
                        break;

                    case "has_shipments":
                        shipments_filters[setting] = hasShipments;
                        break;

                    case "shipmentType":
                        shipments_filters[setting] = shipmentType;
                        break;
                }
            }

            // console.log('shipment filters: ', shipments_filters);

            const payload: IUpdateTokenSettingsDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                settings: {
                    shipments_filters,
                },
                tokenGuid: currentToken.guid,
            };

            socket.emit(EndpointsEnum.TokenUpdateSettings, payload);
        }
    };

    const selectedVendorFn = (vendor: IVendorModel) => {
        setSelectedVendor(vendor);
        setFoundVendors(undefined);
        // setIsOrderSearchDisabled(false);
        setIsCarrierDisabled(false);
    };

    let cardClass = "dark-card text-white bg-secondary";

    if (UIService.isMainViewLight()) {
        cardClass = "";
    }

    return (
        <div className="ShipmentFilter">
            <div className="row mb-2">
                <div className={"col-12 col-md-2 " + (!_.isNil(userModel) && userModel.isSupplierUser ? "" : "d-none")}>
                    <OwLabel
                        title={"vendor"}
                        supplierModel={supplierModel}
                        isSupplierVendorOverride={true}
                        noBottomMargin={true}
                    />
                    <div className="position-relative">
                        <Typeahead
                            className="form-control-sm"
                            clearTypeahead={clearVendorTypeahead}
                            clearTypeaheadCallback={clearVendorTypeaheadFn}
                            typeaheadItems={foundVendors}
                            titleProp="name"
                            subTitleProp=""
                            placeholder=""
                            selectedItem={selectedVendor}
                            isSelectableFn={() => {
                                return true;
                            }}
                            selectedItemFn={selectedVendorFn}
                            typeaheadApiFn={findVendorsByName}
                            onKeyDownFn={enterSearch}
                        />
                    </div>
                </div>
                <div className="col-12 col-md-2">
                    <OwLabel title={"order"} noBottomMargin={true} />
                    <OwInputWrapper name={"order"} value={order} fn={handleChange} onKeyDownFn={enterSearch} />
                </div>
                <div className="col-12 col-md-2">
                    <OwLabel title={"po_no"} noBottomMargin={true} />
                    <OwInputWrapper name={"po_no"} value={poNo} fn={handleChange} onKeyDownFn={enterSearch} />
                </div>
                {supplierModel.has_pick_list_management ? (
                    <div className="col-12 col-md-2">
                        <OwLabel title={"packing_list"} noBottomMargin={true} />
                        <OwInputWrapper name={"packing_list"} value={packingList} fn={handleChange} onKeyDownFn={enterSearch} />
                    </div>
                ) : null}
                <div className={"col-12 col-md-auto"}>
                    <OwLabel title={"type"} />
                    <OwSelectOption
                        options={shipmentTypes}
                        valueProp={"title"}
                        titleProp={"title"}
                        selectedOption={shipmentType}
                        hasSelectedOptionProp={false}
                        name={"shipmentType"}
                        fn={handleChange}
                        translateTitle={true}
                    />
                </div>
                <div className="col-12 col-md-auto d-none">
                    <OwLabel title={"ship_date"} noBottomMargin={true} />
                    <OwDateInput selectedDate={dateSelectedValue} fn={handleDateChange} />
                </div>
                <div className="col-12 col-md-auto d-none">
                    <OwLabel title={"carrier"} noBottomMargin={true} />
                    <OwSelectOption
                        valueProp={"id"}
                        titleProp={"name"}
                        options={shippingCarriers}
                        isDisabled={isCarrierDisabled}
                        name={"shipping_carrier_id"}
                        selectedOption={shippingCarrierId}
                        selectedOptionProp={"shipping_carrier_id"}
                        hasSelectedOptionProp={false}
                        showBlankFirst={true}
                        fn={handleChange}
                    />
                </div>
                <div className="col-12 col-md-auto d-none">
                    <OwLabel title={"status"} noBottomMargin={true} />
                    <OwSelectOption
                        valueProp={"id"}
                        titleProp={"name"}
                        name={"shipment_status_id"}
                        options={shippingStatuses}
                        fn={handleChange}
                        titleRenderFn={(option: any) => {
                            return _.toLower(option.name);
                        }}
                    />
                </div>
                <div className={"col-12 col-md-auto"}>
                    <OwLabel title={""} noBottomMargin={true} />
                    <div className="">
                        <OwCheckbox
                            label={"has_shipments"}
                            fn={handleChange}
                            name={"has_shipments"}
                            truthyVal={true}
                            falsyVal={false}
                            checked={hasShipments}
                        />
                    </div>
                </div>
                {supplierModel.has_local_delivery || supplierModel.has_local_pickup ? (
                    <div className={"col-12 col-md-auto"}>
                        <OwLabel title={""} noBottomMargin={true} />
                        <div className="">
                            <OwCheckbox
                                label={"hide_signed"}
                                fn={handleChange}
                                name={"hide_signed"}
                                truthyVal={true}
                                falsyVal={false}
                                checked={hideSigned}
                            />
                        </div>
                    </div>
                ) : null}
                <div className={"col-12 col-md-auto"}>
                    <OwLabel title={""} noBottomMargin={true} />
                    <div className="">
                        <OwButton title={"search"} fn={performSearch} />
                        {/*<button className="btn btn-primary btn-sm me-2" onClick={performSearch}>Search</button>*/}
                        <OwButton title={"reset"} fn={resetSearch} className={"btn-danger ms-2"} />
                        <OwButton title={"save"} fn={saveSearch} className={"btn-success ms-2"} />
                        {/*<button className="btn btn-danger btn-sm ms-2" onClick={resetSearch}>Reset</button>*/}
                    </div>
                </div>
            </div>
        </div>
    );
};
